import { View, Text, ScrollView, TouchableOpacity, StyleSheet, ActivityIndicator } from "react-native";
import React, { useEffect, useState } from "react";
import { db } from "../firebase";
import { collection, query, where, getDocs } from "firebase/firestore";
import Header from "../components/Header";
import { useStateContext } from "../lib/context";
import { Ionicons } from "@expo/vector-icons";

const Orders = ({ navigation }) => {
  const [operaciones, setOperaciones] = useState([]);
  const [loading, setLoading] = useState(true);
  const { currentUser } = useStateContext();

  useEffect(() => {
    const fetchOrders = async () => {
      try {
        const q = query(
          collection(db, "orders"),
          where("user", "==", currentUser)
        );
        const querySnapshot = await getDocs(q);
        const fetchedOperaciones = [];
        querySnapshot.forEach((doc) => {
          fetchedOperaciones.push(doc.data());
        });
        
        // Sort by date descending
        fetchedOperaciones.sort((a, b) => new Date(b.fecha) - new Date(a.fecha));
        
        setOperaciones(fetchedOperaciones);
      } catch (error) {
        console.error("Error fetching orders:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchOrders();
  }, [currentUser]);

  if (loading) {
    return (
      <View style={localStyles.loadingContainer}>
        <ActivityIndicator size="large" color="#2a2a8e" />
        <Text style={localStyles.loadingText}>Cargando pedidos...</Text>
      </View>
    );
  }

  return (
    <View style={localStyles.container}>
      <Header title={"Mis Pedidos"} navigation={navigation} isBack={true} />
      <ScrollView
        style={localStyles.scrollView}
        contentContainerStyle={localStyles.scrollContent}
        showsVerticalScrollIndicator={false}
      >
        {operaciones.length === 0 ? (
          <View style={localStyles.emptyContainer}>
            <Ionicons name="receipt-outline" size={64} color="#ddd" />
            <Text style={localStyles.emptyText}>No tienes pedidos realizados aún.</Text>
          </View>
        ) : (
          operaciones.map((item, index) => {
            const dateObj = new Date(item.fecha);
            const formattedDate = dateObj.toLocaleDateString("es-AR", {
              day: "2-digit",
              month: "2-digit",
              year: "numeric",
            });
            const formattedTime = dateObj.toLocaleTimeString("es-AR", {
               hour: "2-digit", 
               minute: "2-digit"
            });

            return (
              <TouchableOpacity
                key={index}
                style={localStyles.card}
                onPress={() => navigation.navigate("Order", item)}
                activeOpacity={0.8}
              >
                <View style={localStyles.cardHeader}>
                  <View style={localStyles.dateContainer}>
                    <Ionicons name="calendar-outline" size={16} color="#666" />
                    <Text style={localStyles.dateText}>{formattedDate}</Text>
                    <Text style={localStyles.timeText}>{formattedTime}</Text>
                  </View>
                  <View style={[
                    localStyles.statusBadge,
                    item.estado === "Finalizado" ? localStyles.statusFinalizado : localStyles.statusProcesando
                  ]}>
                    <Text style={[
                      localStyles.statusText,
                      item.estado === "Finalizado" ? localStyles.statusTextFinalizado : localStyles.statusTextProcesando
                    ]}>
                      {item.estado || "Procesando"}
                    </Text>
                  </View>
                </View>

                <View style={localStyles.cardContent}>
                  <View style={localStyles.row}>
                    <Text style={localStyles.label}>Total:</Text>
                    <Text style={localStyles.value}>${Number(item.total).toFixed(2)}</Text>
                  </View>
                  
                  {/* Show Items count if array exists */}
                  {Array.isArray(item.items) && (
                    <View style={localStyles.row}>
                       <Text style={localStyles.label}>Items:</Text>
                       <Text style={localStyles.value}>{item.items.length}</Text>
                    </View>
                  )}

                  {item.discount != "0" && Number(item.discount) > 0 && (
                     <View style={localStyles.row}>
                        <Text style={localStyles.discountLabel}>Descuento:</Text>
                        <Text style={localStyles.discountValue}>-${Number(item.discount).toFixed(2)}</Text>
                     </View>
                  )}
                </View>

              </TouchableOpacity>
            );
          })
        )}
        <View style={{height: 40}} />
      </ScrollView>
    </View>
  );
};

export default Orders;

const localStyles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: "#F4F6FD",
  },
  loadingContainer: {
    flex: 1,
    backgroundColor: "#F4F6FD",
    justifyContent: "center",
    alignItems: "center",
  },
  loadingText: {
    marginTop: 10,
    color: "#666",
  },
  scrollView: {
    flex: 1,
  },
  scrollContent: {
    padding: 20,
  },
  emptyContainer: {
    alignItems: "center",
    marginTop: 60,
  },
  emptyText: {
    marginTop: 16,
    color: "#999",
    fontSize: 16,
  },
  card: {
    backgroundColor: "#fff",
    borderRadius: 12,
    padding: 16,
    marginBottom: 12,
    shadowColor: "#000",
    shadowOffset: { width: 0, height: 2 },
    shadowOpacity: 0.05,
    shadowRadius: 4,
    elevation: 2,
    borderLeftWidth: 4,
    borderLeftColor: "#2a2a8e",
  },
  cardHeader: {
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: 12,
    paddingBottom: 8,
    borderBottomWidth: 1,
    borderBottomColor: "#f0f0f0",
  },
  dateContainer: {
    flexDirection: "row",
    alignItems: "center",
    gap: 6,
  },
  dateText: {
    fontSize: 16,
    fontWeight: "bold",
    color: "#333",
  },
  timeText: {
    fontSize: 14,
    color: "#888",
  },
  cardContent: {
    gap: 6,
  },
  row: {
    flexDirection: "row",
    justifyContent: "space-between",
  },
  label: {
    fontSize: 14,
    color: "#666",
  },
  value: {
    fontSize: 14,
    fontWeight: "600",
    color: "#333",
  },
  discountLabel: {
    fontSize: 14,
    color: "#4CAF50",
    fontWeight: "500",
  },
  discountValue: {
    fontSize: 14,
    fontWeight: "600",
    color: "#4CAF50",
  },
  statusBadge: {
    paddingHorizontal: 10,
    paddingVertical: 4,
    borderRadius: 20,
  },
  statusProcesando: {
    backgroundColor: "#FFF3E0",
    borderWidth: 1,
    borderColor: "#FF9800",
  },
  statusFinalizado: {
    backgroundColor: "#E8F5E9",
    borderWidth: 1,
    borderColor: "#4CAF50",
  },
  statusText: {
    fontSize: 12,
    fontWeight: "600",
  },
  statusTextProcesando: {
    color: "#E65100",
  },
  statusTextFinalizado: {
    color: "#2E7D32",
  },
});
